import React, { useState } from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useFlow } from '../../contexts/FlowContext';
import { WebFlowLayout } from '../WebFlowLayout';
import { BookTitlePreview } from '../components/BookTitlePreview';
import { FlowPrimaryButton } from '../components/FlowPrimaryButton';
import { FlowTextField } from '../components/FlowTextField';
import { StudioFlowColors } from '../studioFlowTheme';
import { SessionAPI } from '../../utils/sessionApi';

export const TitleScreen: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const { state, updateState } = useFlow();
  const [isSaving, setIsSaving] = useState(false);

  const canSave = state.sessionTitle.trim().length > 0 && !isSaving;

  const handleSave = async () => {
    if (!canSave) {
      return;
    }

    setIsSaving(true);
    await SessionAPI.updateWebSession({
      sessionId: state.sessionId,
      sessionTitle: state.sessionTitle.trim(),
    });
    setIsSaving(false);
    navigate('/instructions');
  };

  const saveButton = (
    <FlowPrimaryButton onClick={handleSave} disabled={!canSave}>
      Save title
    </FlowPrimaryButton>
  );

  return (
    <WebFlowLayout
      title="Title your book"
      subtitle="You can change this later"
      largeSubtitle
      maxWidth="md"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          maxWidth: 354,
          mx: 'auto',
          pb: { xs: 14, md: 0 },
        }}
      >
        <BookTitlePreview />

        <Box>
          <FlowTextField
            placeholder="Book title"
            value={state.sessionTitle}
            onChange={(event) => updateState({ sessionTitle: event.target.value })}
            inputProps={{ maxLength: 35 }}
          />
          <Typography
            sx={{
              color: StudioFlowColors.subtitle,
              fontFamily: StudioFlowColors.bodyFontFamily,
              fontSize: 13,
              mt: 1,
              display: 'block',
            }}
          >
            {state.sessionTitle.length}/35 characters
          </Typography>
        </Box>

        {isDesktop && saveButton}
      </Box>
      {!isDesktop && (
        <Box
          sx={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            bgcolor: StudioFlowColors.background,
            px: 3,
            pt: 2,
            pb: 'calc(16px + env(safe-area-inset-bottom))',
          }}
        >
          {saveButton}
        </Box>
      )}
    </WebFlowLayout>
  );
};
